<div class="multi-select-pills" role="list">
  @for (item of items; track item.id) {
    <rv-badge
      role="listitem"
      shape="input"
      color="gray"
      [text]="item.label"
      [removable]="true"
      [removeAriaLabel]="'Remove ' + item.label"
      [matTooltip]="item.label"
      [matTooltipDisabled]="!item.label"
      matTooltipPosition="above"
      (removed)="onRemove(item.id)"
    />
  }
</div>
